/*
 * --------------------------------------------------------------------------
 * CATEGORY LISTING PAGE FUNCTIONS STARTS
 * ----------------------------------------------------------------------------
 */

function initialize_products_over() {

    products = $(".wcs-category-listing .wcs-product-group, .wcs-recently-viewed-wrapper .wcs-product-group");

    var show_product_over = function($this, e) {
        product = $($this).find('.wcs-product:not(.wcs-quick-buy .wcs-product)');
        quick_buy = $($this).find('.wcs-quick-buy');
        if (product.is(':visible')) {
            $(product).css('display', 'none');
            $(quick_buy).css('display', 'block');
        }
    };

    if ($('body').is('.android')) {
        products.off("click").on("click", function(e) {
            show_product_over(this, e);
        });
        products.find('.wcs-product:not(.wcs-pos-relative) a').off('click.hover').on('click.hover', function(e){
            e.preventDefault();
        });
    } else {
        $(products).off("mouseenter").on("mouseenter", function(e) {
            show_product_over(this, e);
        });
    }
}

function initialize_products_out() {

    products = $(".wcs-category-listing .wcs-product-group, .wcs-recently-viewed-wrapper .wcs-product-group");

    var show_products_out = function($this, e) {
        product = $($this).find('.wcs-product:not(.wcs-quick-buy .wcs-product)');
        quick_buy = $($this).find('.wcs-quick-buy');
        if (quick_buy.is(':visible')) {
            $(product).css('display', 'block');
            $(quick_buy).css('display', 'none');
        }
    };

    $(products).off("mouseleave").on("mouseleave", function(e) {
        show_products_out(this, e);
    });
}

function categoryListing() {
    /* Function to remove the empty row in category listing page */
    //$('.wrapper:has(*)').removeClass('wcs-hide').siblings('.wcs-hide').removeClass('wcs-hide');
    $('.wrapper.wcs-alpha').each(function() {
        var getChild = $(this).children().length;
        if (getChild === 0) {
            var getFirstNextChild = $(this).next().children().length;
            if (getFirstNextChild === 0) {
                var getSecondNextChild = $(this).next().next().children().length;
                if (getSecondNextChild === 0) {
                    var getLastChild = $(this).next().next().next().children().length;
                    if (getLastChild === 0) {
                        $(this).addClass('wcs-hide');
                        $(this).next().addClass('wcs-hide');
                        $(this).next().next().addClass('wcs-hide');
                        $(this).next().next().next().addClass('wcs-hide');
                    }
                }
            }
        }
    });


    var filter_links = $(".wcs-filter-drop .wcs-filter-container a"),
        content = $(".wcs-category-listing.wcs-main"),
        add_bag = $(".wcs-quick-buy .wcs-add-bag"),
        filter_link = $('.wcs-filter-link'),
        filter_container = $('.wcs-filter-container'),
        filter_inner_container = $('.wcs-filter-inner-container'),
        filter_close = $('.wcs-filter-container .wcs-close-btn'),
        filters = $('.wcs-filters li'),
        filter_products = $('.wcs-filter-products > div'),
        dropdown = $('.wcs-custom-dropdown-select'),
        selected_text = $('.wcs-custom-dropdown li'),
        star = $(".wcs-star"),
    dropdown_text = $('.wcs-dropdown-text'),
    dropdown_icon = $('.wcs-dropdown-icon'),
    dropdownscroller = $('.dropscroller'),
    slider_visible_product = 4;

    window.product_ID_fn = function(e) {
        var productID = $(e.target).data("product_id");
        var catEntryIdMySelection = productID.split('_')[1];
        var configurationID = $(e.target).data("configuration_id");

        var addToBagFormHtml = '<div>' + $('[data-product_id="' + productID + '"]').closest('form').html() + '</div>';
        if (window.Rayban && Rayban.PrivateSaleInstance && !Rayban.PrivateSaleInstance.userTryToAddProduct(addToBagFormHtml)) {
            e.preventDefault();
            return false;
        }

        if ($(e.target).parents().is('.wcs-qty-container')) {
            if ($(e.target).parents('.wcs-qty-container').find('.wcs-qty .wcs-dropdown-text').length > 0) {
                add_quantity = $(e.target).parents('.wcs-qty-container').find('.wcs-qty .wcs-dropdown-text').val();
            } else {
                add_quantity = 1;
            }
        } else {
            add_quantity = 1;
        }
        var addedButton = $(e.target).siblings("#" + $(e.target).data("added_button"));

        $(e.target).hide();
        addedButton.show();

        var getParentAttr = $(e.target).parent().find('input[type="hidden"]');
        $(e.target).addClass('wcs-added-to-bag');

        var updateCart = new CustomEvent('addToBag', {detail: {isAddToBagFromMySelection: true, catEntryId: catEntryIdMySelection}});
        document.dispatchEvent(updateCart);
        if (getParentAttr.length) {
            window.product_opration("add_product", getParentAttr);
        }

        if ($(e.target).data("removefromstar")) {
            $(e.target).parents('.wcs-product-compare').find('.wcs-remove-star-pd span').attr('starRemove', false);
            $(e.target).parents('.wcs-product-compare').find('.wcs-remove-star-pd span').trigger("click");
            if ($(e.target).parents().is('.wcs-Product-compare-lightbox')) {
                var productIdValue = productID.split('_')[1];
                var selector = $('a[catalogentryid=' + productIdValue + ']');
                selector.find('span').trigger("click");
            }
        }

        if ($(e.target).parents().is('.wcs-Product-compare-lightbox')) {

            if ($(e.target).attr("id") == "wcs-add-both-to-bag") {
                e.stopPropagation();
                var catid1, catid2;
                var configurationid1, configurationid2;
                var listid = ".";
                var cookieValue = getCookie("comparePros");
                var catentryList = cookieValue.split("_");
                var removeValueList = catentryList[0].split("/");
                var roxSet1 = "";
                var count = 0;
                if (removeValueList[1] == "true") {
                    catid1 = removeValueList[0];
                    configurationid1 = removeValueList[2];
                    roxSet1 = removeValueList[3];
                    roxSet1 = roxSet1.replace(/%24/g, '_');
                    ++count;
                }
                removeValueList = catentryList[1].split("/");
                if (removeValueList[1] == "true") {
                    catid2 = removeValueList[0];
                    configurationid2 = removeValueList[2];
                    roxSet2 = removeValueList[3];
                    roxSet2 = roxSet2.replace(/%24/g, '_');
                    ++count;
                }
                var catIdArr = new Array(count);
                for (i = 1; i <= count; i++) {
                    if (i == 1) {
                        catIdArr[0] = catid1;
                    }
                    if (i == 2) {
                        catIdArr[1] = catid2;
                    }
                }
                if(configurationid1 == "empty") {
                	configurationid1 ="";
                }
                if(configurationid2 == "empty") {
                	configurationid2 ="";
                }
                var configurationIdArr = new Array(count);
                for (i = 1; i <= count; i++) {
                    if (i == 1) {
                        configurationIdArr[0] = configurationid1;
                    }
                    if (i == 2) {
                        configurationIdArr[1] = configurationid2;
                    }
                }
                var roxSetArr = "";
                if(roxSet1 !== "" && roxSet2 !== ""){
	                roxSetArr = new Array(count);
	                for (i = 1; i <= count; i++) {
	                    if (i == 1 && roxSet1 !== "") {
	                    	roxSetArr[0] = roxSet1;
	                    	configurationIdArr[0] = roxSet1;
	                    }
	                    if (i == 2 && roxSet2 !== "") {
	                    	roxSetArr[1] = roxSet2;
	                    	configurationIdArr[1] = roxSet2;
	                    }
	                }
                }else{
                	roxSetArr = "";
                }
                var updateCart = new CustomEvent('addToBag', { detail: {isAddToBagFromMySelection: true, catEntryId1: catid1, catEntryId2: catid2}});
                document.dispatchEvent(updateCart);
                window.remove_star_item(catIdArr, listid, configurationIdArr, false, roxSetArr);
            }
        }
        e.preventDefault();
    };
    window.product_miniID_fn = function(e) {
        add_quantity = 1;
        var product_miniID = $(e.target).data("product_mini_id");
        var roxSet = $(e.target).data("roxset");
        var product_xdkiitemID = $(e.target).data("product_xdkiitem_id");
        var product_configuration_miniID = $(e.target).data("product_mini_configuration_id");
        var addedButton = $(e.target).siblings("#" + $(e.target).data("added_button"));

        var catIdArr = new Array(1);
        catIdArr[0] = product_miniID;
        var configurationIdArr;
        if (product_configuration_miniID !== "" && product_configuration_miniID !== undefined) {
            configurationIdArr = new Array(1);
            configurationIdArr[0] = product_configuration_miniID;
        } else {
            configurationIdArr = new Array(0);
        }
        var roxSetArr;
        if (roxSet !== "" && roxSet !== undefined) {
            roxSetArr = new Array(1);
            roxSetArr[0] = roxSet;
        } else {
            roxSetArr = new Array(0);
        }
        e.stopPropagation();
        $('.wcs-content-bag .wcs-home-try, .wcs-content-bag .wcs-cost-container').removeClass('wcs-hide');

        $(e.target).fadeOut('1500', function() {
            $(addedButton).removeClass('wcs-left-82');
        });

        setTimeout(function() {
            $(addedButton).fadeIn('1500');
        }, 100);

        setTimeout(function() {
            $(addedButton).fadeOut('2000');
            setTimeout(function() {
                //$(addedButton).addClass('wcs-left-82');
                $(e.target).fadeIn('1000', function() {

                    if ($(e.target).hasClass('wcs-tryon-athome')) {
                        add_product_to_hometry();
                    } else if ($(e.target).hasClass('wcs-addtobag')) {

                        $(e.target).parents('.wcs-product-description').parent().animate({
                            height: 'toggle',
                            opacity: 'toggle',
                            margin: '0 30px 0',
                            padding: '0'
                        }, 'slow', function() {
                            wcs_add_product_star_to_bag(product_miniID, product_configuration_miniID, roxSet);
                            var updateCart = new CustomEvent('addToBag', {});
                            document.dispatchEvent(updateCart);
                            window.remove_star_item(catIdArr, ".", configurationIdArr, false, roxSetArr);
                        });
                    }

                    window.shortlist_tray_length();
                    //add_product_notification(bag);
                });
            }, 100);
        }, 2000);
    };
    $(document).off("click.wcs").on("click.wcs", function(e) {


        //we exit if the click is a fake click triggered by iScroll
        if (e && e.originalEvent && e.originalEvent._fake) {
            e.stopPropagation();
            return;
        }

        if("ProductPage" == $("input[name='pageName']").val() &&
    			("SUN" == $("input[name='productType']").val() || "OPTICAL" == $("input[name='productType']").val())){
    		if("Select" == $('#D_PDP_Prod_SizeDropdownBtn .dd-selected-value').val()){
    			$('#wcs-size-pdp-display .qty-stock-msg').removeClass('wcs-hide');
    			return;
    		}
    	}
        if ($(e.target).hasClass('minicart-wishlist-addtobag')){
        	//RB-16047 Removing the Call as per comments
        	/*var onClickAnalytics=$(e.target).data("onclick");
        	window.tealium_data2track = window.tealium_data2track || [];
        	window.tealium_data2track.push({
        		id: 'X-X-X-MiniCartOverlay-Open',
        		productList: onClickAnalytics
        	});*/
    	}
        if (e.which != 3) {
            if ($(e.target).is('.wcs-tax-calculate .wcs-close') || !($(e.target).is('.wcs-tax-calculate') || $(e.target).parents().is('.wcs-tax-calculate')) && !($(e.target).is('#wcs-calculate-tax') || $(e.target).is('#wcs-recalculate-tax'))) {
                $('#wcs_calTax_notification').hide();
            }
            if (!$(e.target).is('.wcs-login-link, .wcs-login-link span')) {
                $('.wcs-myacc-login').slideUp();
            }
            var source = $(e.target).data("source");
            if (source) {
                $.get(source, function(data) {
                    $(content).html(data);
                    initialize_products_over();
                    initialize_products_out();
                    add_star_mouseOver_event();
                });
                e.preventDefault();
            }

            var productID = $(e.target).data("product_id");
            var product_miniID = $(e.target).data("product_mini_id");

            if (productID) {
                if($(e.target).hasClass("wcs-addtobag") && $(e.target).parent().parent().parent().parent().hasClass("wcs-quickbuy-product-info")){
                    //setTimeout(function(){product_ID_fn(e)},2000);
					if($(".info-wrapper").hasClass("clearance-qv")){
						product_ID_fn(e);
					}
                }
                else {
				product_ID_fn(e);
				}
            } else if (product_miniID) {
                product_miniID_fn(e);
            }

            var saveID = $(e.target).data("save_id");
            if (saveID) {
                if (!$($(e.target).siblings()[0]).hasClass('wcs-saved')) {
                    window.product_opration("save_product", "");

                }
                e.preventDefault();
            }

            var quickBuyID = $(e.target).data("quick_buy_id");
            if (quickBuyID) {
                window.show_quick_buy($(e.target));
            }

            var viewAll = $(e.target).data("view_all");
            if (viewAll) {
                e.preventDefault();
                var products = $('.' + viewAll).hide().removeClass("wcs-hidden-products");
                var container = $(e.target).parent().parent().parent().parent();
                $(container).fadeOut("slow", function() {
                    container.remove();
                    refactor();
                    $(products).fadeIn('fast', 'swing', function() {
                        initialize_products_over();
                        initialize_products_out();
                        add_star_mouseOver_event();
                    });
                });
            }
            /* close right panel */
            if ($('.wcs-right-panel > div').is(":visible") && (!$(e.target).parents().is('.wcs-right-slider-nav')) && (!$(e.target).parents().is('.wcs-right-panel')) && (!$(e.target).is('.wcs-fadeout-full')) && (!$(e.target).parents().is('.wcs-right-nav')) && (!$(e.target).is('#wcs_email_to_friendFavView') && !$(e.target).parents().is('#wcs_email_to_friendFavView'))) {
                slide_back_right_panel();
            }
            /* close footer */
            if (!$(e.target).parents().is('.wcs-footer') && !$(e.target).parents().is('.wcs-footer-checkout')) {
                $('.wcs-footer .wcs-countryClass').slideUp();
                $('.wcs-footer .wcs-helpClass, .wcs-footer-checkout .wcs-helpClass,#wcs_contact_us_content').slideUp();
                $('#helpId,#wcs_contact_us').removeClass('wcs-white');

            }
            /* close dropdown boxes */
            if (!$(e.target).is('.wcs-dropdown-text') && !$(e.target).is('div[data-scrollbarindicator="true"]') && !$(e.target).is('.wcs-dropdown-icon') && !$(e.target).is('.wcs-custom-dropdown-select')) {
                collapse_dropbox();
            }

            /* delete products from minicart */
            var removeProduct = $(e.target).parent().hasClass('remove-product'),
                delContainer = $(e.currentTarget).parent();
                shoping_cart = $('#wcs-cart-container');
            var configurationId;
            if (removeProduct) {
            	delContainer.hide();
                itemId = $(e.target).parent().attr('rel');
                configurationId = $(e.target).parent().attr('rel-configurationId');
                roxSet1 = $(e.target).parent().attr('rel-roxSet');
                orderIdToDelete = $(e.target).parent().attr('rel-order');
                catEntryId = $(e.target).parent().attr('catalogEntryId');

                if ($("span[data-element-id='wcs-remove-item" + itemId + "']").length > 0) {
                    $(e.target).parent().animate({
                        height: 'toggle',
                        opacity: 'toggle',
                        margin: '0 30px 0',
                        padding: '0'
                    }, 'slow', function() {
                        $(this).remove();
                        shopping_item_remove($("span[data-element-id='wcs-remove-item" + itemId + "']"));
                        home_try_length();
                        show_empty_container();
                        dropscrollerFn();
                        select_dropbox_value();
                        expand_dropbox();
                        collapse_dropbox();
                        key_nav_dropdown();
                        dropscroller_hover_fn();
                        $(".wcs-product-count-circle").removeClass('wcs-hide');
                        $('#wcs-cart-container').children().remove();
                    });
                } else {
                    $(this).remove();
                    $.ajax({
                        url: "AjaxOrderItemUpdate?doInventory=N&quantity=0&orderItemId=" + itemId + "&orderId=" + orderIdToDelete + "&isDeleteFromCart=true",
                        async: false
                    }).done(function() {
                        $(e.target).parent().parent().animate({
                            height: 'toggle',
                            opacity: 'toggle',
                            margin: '0 30px 0',
                            padding: '0'
                        }, 'slow', function() {

                            sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".sidebar_refreshLS");
                            sessionStorage.removeItem("rayban." + $("#storeId").val() + "." + $("#langId").val() + ".headerprofile_refreshLS");

                            add_product_tostar_remove_from_basket(catEntryId, configurationId, roxSet1);
                            var getAttrId = $(this).attr("id");
                            $.publish("removeItemFromCart", {
                                objectId: getAttrId
                            });
                            home_try_length();

                            if ($('#inputLineIDForDMP').length > 0 && itemId == $('#inputLineIDForDMP').val()) {
                                window.refresh_DMP_LineId('');
                            }


                            show_empty_container();
                            dropscrollerFn();
                            select_dropbox_value();
                            expand_dropbox();
                            collapse_dropbox();
                            key_nav_dropdown();
                            dropscroller_hover_fn();
                            setUrlInSession();
                            remove_freeMessage();
                            $(".wcs-product-count-circle").removeClass('wcs-hide');
                            $('#wcs-cart-container').children().remove();
                            $('#wcs-cart-container').load("MiniCartView?storeId=" + $("#storeId").val() + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
                                shoping_cart_length();
                                show_deposit_container();
                                custom_scrollable_hover();
                                scroller(true);
                                openLinksInNewTab();
                                shoprunnerUpdateContent();
                                if ($("#promotionCode").length > 0 && $("#promotionCode").val() !== "" && $('#tcount').length > 0 && ($("#tcount").val() === 0 || $("#tcount").val() === "")) {
                                    var params = {};
                                    params.promoCode = $("#promotionCode").val();
                                    params.orderId = $('#orderId').val();
                                    params.taskType = 'R';
                                    $.ajax({
                                        type: "POST",
                                        url: "AjaxPromotionCodeManage",
                                        data: params,
                                        success: function(data) {
                                            $('#wcs-cart-container').load("MiniCartView?storeId=" + $("#storeId").val() + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
                                                shoping_cart_length();
                                                show_deposit_container();
                                                custom_scrollable_hover();
                                                scroller(true);
                                                openLinksInNewTab();
                                                shoprunnerUpdateContent();
                                            });
                                        }
                                    });
                                }
                            });
                        });
                    }).fail(function() {
                    	delContainer.show();
                    });
                }
            }

            //wish list remove method
            var removeStarProduct = $(e.target).parent().hasClass('wcs-remove-star-pd');
            if (removeStarProduct) {
                e.stopPropagation();
                var selector = $(e.target).parent();
                var roxSet = selector.attr('rel-roxSet');
                var catid = selector.attr('catalogEntryId');
                var xdkiitemId = selector.attr('xdkiitemId');
                configurationId = selector.attr('rel-configurationId');
                var isRemoveFromStar = selector.attr('starRemove');
                var listid = selector.attr('rel');
                var catIdArr = new Array(1);
                catIdArr[0] = catid;
                var configurationIdArr;
                starUPC = selector.parent().find('input[name="partNumberFavVal"]').val();
                if (configurationId !== "" && configurationId !== undefined) {
                    configurationIdArr = new Array(1);
                    configurationIdArr[0] = configurationId;
                } else {
                    configurationIdArr = new Array(0);
                }

                var roxSetArr;
                if (roxSet !== "" && roxSet !== undefined) {
                    roxSetArr = new Array(1);
                    roxSetArr[0] = roxSet;
                } else {
                    roxSetArr = new Array(0);
                }

                $(e.target).parent().parent().animate({
                    height: 'toggle',
                    opacity: 'toggle',
                    margin: '0 30px 0',
                    padding: '0'
                }, 'slow', function() {
                	var updateCart = new CustomEvent('addToBag', {});
                    document.dispatchEvent(updateCart);
                    window.remove_star_item(catIdArr, listid, configurationIdArr, isRemoveFromStar, roxSetArr);
                });
            }

        }
        if($(e.target).attr("class") == "wcs-fadeout-full"){
              $(".wcs-quick-buy-lightbox:visible").hide();
              $(".wcs-fadeout-full").css("height","0px");

  	    	var video = $("#wcs-youtube-video iframe").attr("src");
	    	$("#wcs-youtube-video iframe").attr("src","");
	    	$("#wcs-youtube-video iframe").attr("src",video);


	    	video = $("#wcs-popup-video iframe").attr("src");
	    	$("#wcs-popup-video iframe").attr("src","");
	    	$("#wcs-popup-video iframe").attr("src",video);


	    	video = $("#wcs-youku-video iframe").attr("src");
	    	$("#wcs-youku-video iframe").attr("src","");
	    	$("#wcs-youku-video iframe").attr("src",video);
        }
		if($(e.target).attr("class") == "wcs-close-btn"){
		      $(".wcs-quick-buy-lightbox:visible").hide();
              $(".wcs-fadeout-full").css("height","0px");

			var video1 = $("#wcs-youtube-video iframe").attr("src");
	    	$("#wcs-youtube-video iframe").attr("src","");
	    	$("#wcs-youtube-video iframe").attr("src",video1);


	    	video1 = $("#wcs-popup-video iframe").attr("src");
	    	$("#wcs-popup-video iframe").attr("src","");
	    	$("#wcs-popup-video iframe").attr("src",video1);


	    	video1 = $("#wcs-youku-video iframe").attr("src");
	    	$("#wcs-youku-video iframe").attr("src","");
	    	$("#wcs-youku-video iframe").attr("src",video1);
        }
    });
    /* for calculate tax ie issue */
    if ($.browser.msie) {
        $('input.wcs-zipcode-tax-cal').click(function(e) {
            e.stopPropagation();
        });
    }
    window.remove_star_item = function(catEntryIdArr, listId, configurationIdArr, isRemoveFromStar, roxSetArr) {
        var params;
        var callDelete = true;
        if (catEntryIdArr.length == 1) {
            params = {};
            params.catEntryId = catEntryIdArr[0].replace("add_", "");
            params.listId = listId;
            params.isOnlyRemoveFromStar = isRemoveFromStar;
            if (configurationIdArr.length == 1) {
                params.configurationId = configurationIdArr[0];
            }
            if (roxSetArr.length == 1) {
                params.roxSet = roxSetArr[0];
                params.configurationId = roxSetArr[0];
            }
        } else if (catEntryIdArr.length > 1) {
            params = "listId=" + listId;
            for (i = 0; i < catEntryIdArr.length; i++) {
                params = params + "&catEntryId=" + catEntryIdArr[i].replace("add_", "");
            }
            if (roxSetArr.length > 1) {
                for (i = 0; i < roxSetArr.length; i++) {
                    params = params + "&roxSet=" + roxSetArr[i];
                    params = params + "&configurationId=" + roxSetArr[i];
                }
            } else {
            	if (configurationIdArr.length > 1) {
                    for (i = 0; i < configurationIdArr.length; i++) {
                        params = params + "&configurationId=" + configurationIdArr[i];
                    }
                }
            }
            params = params + "&isOnlyRemoveFromStar=" + isRemoveFromStar;
        } else {
            callDelete = false;
        }

        if (callDelete) {
            $.ajax({
                type: "POST",
                dataType: "json",
                url: "AjaxInterestItemDelete",
                data: params,

            }).done(function() {
                var page = $('#pName').val();
                var viewname = "WishListView";
                if (undefined !== page && page == 'remixconfigurator') {
                    viewname = "MiniListView";
                }

                $("#wcs-star-container").load(viewname + "?storeId=" + $("#storeId").val() + "&catalogId=" + $("#catalogId").val() + "&langId=" + $("#langId").val(), function() {
                    sidebarHideFavEmptyDiv();
                    window.add_product_notification(star);
                    window.shortlist_tray_length();
                    custom_scrollable_hover();
                    scroller();
                    $('.wcs-fav-container').find('.wcs-save[data-save_id = ' + catEntryIdArr + ']').prev().removeClass('wcs-saved').addClass('wcs-quickbuy-star');
                    resize_panel_header_footer();
                    sharePlus_emailToFriend_bind();
                    openLinksInNewTab();
                });

                // refresh_my_favorites_section();

                var wishListCatentryIds = $("#wishListCatentryIds").val();
                wishListCatentryIds = !!wishListCatentryIds?wishListCatentryIds.replace(params.catEntryId,'').replace(',,',',').replace(',]',']').replace('[,','['):"";
                $("#wishListCatentryIds").val(wishListCatentryIds);

                if (roxSetArr.length > 0 && typeof(pdpRoxInst) !== "undefined" && null !== pdpRoxInst) {
                    pdpRoxInst.checkifAddedToWishList("FALSE");
                }else if(typeof(pdpObj) !== "undefined"  && null !== pdpObj){
                	pdpObj.checkifAddedToWishList("FALSE");
                }else{
                    $.publish('SITE_MAIN_CHECK_WISHLIST_ADD',{ bool: 'FALSE' });
                }


                $("#wcs-star-container").children().remove();
                var starButton = $('#D_PDP_Prod_AddToWishList');
                if ($('input[name="pageName"]').val() === 'ProductPage'){
                    if (window.location.href.includes(starUPC)){
                      $('.wcs-quickbuy-star').removeClass('wcs-pdp-tickMark');
                      starButton.removeClass('wcs-favourite-added');
                      starButton.html(starButton.attr('data-revert-label'))
                    }
                }
                location.reload();
            });
        }
    };

    var refactor = function() {
        var form_entities = $(".form_entity").parent();
        var grid_size = 12;
        var total = 0;
        var first = true;
        $.each(form_entities, function() {
            if (!first) {
                $(this).removeClass("wcs-alpha");
                $(this).removeClass("wcs-omega");
            }
            first = false;
        });

        $.each(form_entities, function() {
            if (!$(this).hasClass("wcs-hidden-products")) {
                total += $(this).find("div:first-child").data("cell_size");

                if (total % grid_size === 0) {
                    $(this).addClass("wcs-omega");
                    $(this).next().addClass("wcs-alpha");
                }
            }
        });
    };
    window.add_star_mouseOver_event = function() {
        $(".wcs-save").hover(function() {
            $(this).siblings().addClass('wcs-star-active');
        }, function() {
            $(this).siblings().removeClass('wcs-star-active');
        });
    };
    initialize_products_over();
    initialize_products_out();
    add_star_mouseOver_event();

    filterbar();
    open_filter();
    close_filter();
    close_filter_outside();

    window.selected_compare_highlight = function(curObject) {
        curObject.addClass('wcs-select-compare').parents('div.wcs-compare-thumb').addClass('wcs-black-border');
    };
    window.remove_selected_highlight = function(curObject) {
        curObject.removeClass('wcs-select-compare compare compare-1 compare-2 wcs-c-on').parents('div.wcs-compare-thumb').removeClass('wcs-black-border');
        $('.wcs-compare-products-button').removeClass('wcs-button-black').addClass('wcs-button-grey').find('.wcs-item-count').html('0');
        $('#js-compare-products-btn').prop('disabled', true);
        curObject.children('input:checkbox').attr('checked', false);
    };

    var compareArr = [];
    var compareCount = 0;
    window.addid = function (curObject) {
        var disabledLabelClass = 'disabled-label';
        const $currObjectContainer = curObject.closest('.wcs-product-compare');
        const $allItems = $('.wcs-product-compare');
        const $allLabels = $('label[for="compareCheckbox"]');
        function enableAllItems() {
            $allLabels.removeClass(disabledLabelClass);
        };
        function disableCurrentItem(item) {
            item.find('label[for="compareCheckbox"]').addClass(disabledLabelClass);
        }
        if (curObject.hasClass('wcs-compare-cbox')) {
            var other = $('label.wcs-compare-cbox.wcs-c-on').not(curObject);
            if (other.length > 0) {
                var otherRemixed = other.parents('.wcs-product-compare').find('.wcs-remixed-label-my-selections').length > 0;
                var currentRemixed = curObject.parents('.wcs-product-compare').find('.wcs-remixed-label-my-selections').length > 0;
                if (otherRemixed != currentRemixed) {
                    curObject.find('input')[0].checked = false;
                    return false;
                }
                /**if first product is prescription and current product is not a prescription**/
                var otherPrescription = other.parents('.wcs-product-compare').find(".DESK_ROX_Label").length > 0;
                var currentPrescription = curObject.parents('.wcs-product-compare').find(".DESK_ROX_Label").length > 0;
                if (otherPrescription != currentPrescription) {
                    curObject.find('input')[0].checked = false;
                    return false;
                }
            }
        }
        if (!curObject.hasClass('compare')) {
            if (!compareArr.length) {
                compareArr.push(curObject);
                compareArr[0].addClass('compare compare-1');
                selected_compare_highlight(curObject);
                $('.wcs-item-count').html(++compareCount);
            } else {
                if (!curObject.hasClass('compare')) {
                    curObject.addClass('compare compare-2');
                    selected_compare_highlight(curObject);
                    compareArr.push(curObject);
                    $('.wcs-item-count').html(++compareCount);
                };
            };
            if (compareArr.length == 3) {
                remove_selected_highlight(compareArr[0]);
                compareArr.shift();
                compareArr[0].removeClass('compare-1 compare-2').addClass('compare-1');
                compareArr[1].removeClass('compare-1 compare-2').addClass('compare-2');
                $('.wcs-item-count').html(--compareCount);
            };
            if (compareCount == 2) {
                $('.wcs-compare-products-button').removeClass('wcs-button-grey').addClass('wcs-button-black');
                $('#js-compare-products-btn').prop('disabled', false);
            };
        } else if (!curObject.children('input:checkbox').is(':checked')) {
            for (var i in compareArr) {
                if (curObject.is(compareArr[i])) {
                    compareArr.splice(i, 1);
                    break;
                };
            };
            remove_selected_highlight(curObject);
            $('.wcs-item-count').html(--compareCount);
            $('.wcs-compare-products-button').removeClass('wcs-button-black').addClass('wcs-button-grey');
            $('#js-compare-products-btn').prop('disabled', true);
        };
        if (compareCount === 0) {
            enableAllItems();
            return;
        };
        if (compareCount === 1) {
            if ($currObjectContainer.find('.js-product-electronics').length > 0) {
                enableAllItems();
                $allItems.each(function () {
                    var curItem = $(this);
                    if (curItem.find('.js-product-electronics').length === 0) {
                        disableCurrentItem(curItem);
                    };
                });
                return;
            };
            if ($currObjectContainer.find('.js-product-giftcard').length > 0) {
                enableAllItems();
                $allItems.each(function () {
                    var curItem = $(this);
                    if (curItem.find('.js-product-giftcard').length === 0) {
                        disableCurrentItem(curItem);
                    };
                });
                return;
            };
            if ($currObjectContainer.find('.DESK_ROX_Label').length > 0) {
                enableAllItems();
                $allItems.each(function () {
                    var curItem = $(this);
                    if (curItem.find('.DESK_ROX_Label').length === 0) {
                        disableCurrentItem(curItem);
                    };
                });
                return;
            };
            if ($currObjectContainer.find('.common__icon--remix').length > 0 && $currObjectContainer.find('.RoxRemix-label-my-selections').length === 0) {
                enableAllItems();
                $allItems.each(function () {
                    var curItem = $(this);
                    if ((curItem.find('.common__icon--remix').length === 0 && curItem.find('.RoxRemix-label-my-selections').length === 0) || (curItem.find('.RoxRemix-label-my-selections').length === 1 && curItem.find('.common__icon--remix').length === 1)) {
                        disableCurrentItem(curItem);
                    };
                });
                return;
            };
            if ($currObjectContainer.find('.RoxRemix-label-my-selections').length > 0 && $currObjectContainer.find('.common__icon--remix').length === 1) {
                enableAllItems();
                $allItems.each(function () {
                    var curItem = $(this);
                    if (curItem.find('.RoxRemix-label-my-selections').length === 0 && (curItem.find('.common__icon--remix').length === 0 || curItem.find('.common__icon--remix').length === 1)) {
                        disableCurrentItem(curItem);
                    };
                });
                return;
            };
            enableAllItems();
            $allItems.each(function () {
                var curItem = $(this);
                if (curItem.find('.RoxRemix-label-my-selections, .common__icon--remix, .DESK_ROX_Label, .js-product-electronics, .js-product-giftcard').length > 0) {
                    disableCurrentItem(curItem);
                };
            });
            return;
        };
    };

    window.reset_compare = function() {
        $('label[for="compareCheckbox"]').removeClass('disabled-label');
        remove_selected_highlight($('.compare'));
        compareArr = [];
        compareCount = 0;
    };
    /* Compare overlay Read more description */
    $('#wcs_compare_quickview').on('click', '.wcs-cp-show-full-description', function() {
        $('#wcs_compare_quickview .wcs-cp-short-desc').addClass('wcs-hide');
        $('#wcs_compare_quickview .wcs-cp-full-desc').removeClass('wcs-hide');
        /*var eq_ht = 0;
					$('#wcs_compare_quickview .wcs-cp-readmore-container').each(function(){
						var this_height = $(this).height();
						if (this_height > eq_ht){
							eq_ht = this_height;
						}
					});
					$('.wcs-cp-readmore-container').css('height',eq_ht+'px'); */

        /* Compare overlay - dynamic height for vertical line - RB-10032 */
        if ($.trim($("#wcs-compare-view .wcs-cp-full-desc").text()) !== "") {
            var heightOnLeft = $("#wcs-compare-view .wcs-cp-readmore-container").eq(0).height();
            var heightOnRight = $("#wcs-compare-view .wcs-cp-readmore-container").eq(1).height();
            var height = (heightOnLeft > heightOnRight) ? heightOnLeft : heightOnRight;
            $("#wcs-compare-view .wcs-cp-readmore-container").css("height", height);

            if ($("#wcs-compare-view").parent().hasClass("wcs-remixed-compare-view")) {
                $("#wcs-compare-view .wcs-compare-products-divider").css("height", 814 + height);
            } else {
                $("#wcs-compare-view .wcs-compare-products-divider").css("height", 605 + height);
            }
        } else {
            if ($("#wcs-compare-view").parent().hasClass("wcs-remixed-compare-view")) {
                $("#wcs-compare-view .wcs-compare-products-divider").css("height", 814);
            } else {
                $("#wcs-compare-view .wcs-compare-products-divider").css("height", 605);
            }
        }

    });
    var is_compare_favorite = sessionStorage.getItem('COMPAREFAVORITE');
    if (window.location.href.indexOf('suggestCompareFav') != -1) {
        if (is_compare_favorite === null || is_compare_favorite == 'undefined') {
            sessionStorage.setItem("COMPAREFAVORITE", "YES");

            $('#wcs-how-to-compare').parent().css('display','block')
            $('#wcs-how-to-compare').removeClass('wcs-hide');

            var docht = $(document).height(),
                cp_suggest = $('#wcs-how-to-compare'),
                scrollTop = $(document).scrollTop(),
                left = ($(window).width() - cp_suggest.width()) / 2,
                top = ($(window).height() - cp_suggest.height()) / 2 + scrollTop;

            $('.wcs-fadeout-full').removeClass('wcs-hide').css({
                'height': docht + 'px',
                'z-index': '101'
            });
            $(cp_suggest).css({
                'left': left,
                'top': top
            });
        }
    }
    $('.wcs-cp-fav-link').off('click').on('click', function() {
        sessionStorage.removeItem('COMPAREFAVORITE');
    });

    custom_label();
    setupLabel('');
    filter_frame();
    expand_dropbox();
    key_nav_dropdown();
    select_dropbox_value();

    window.fetchMarketingContent = function(espotName) {
        var params = {};
        params.storeId = $('#storeId').val();
        params.catalogId = $('#catalogId').val();
        params.langId = $('#langId').val();
        params.fromAjaxView = true;
        params.espot = espotName;
        $.ajax({
            type: "GET",
            url: "PDPLegendsView",
            dataType: "html",
            data: params,
            cache: false,
            async: false,
            success: function(response) {
                $("#legendsView").html('');
                $("#legendsView").html(response);
            }
        });
    };

    window.BazaarVoiceReviewsAndRatings = function(catentryID, Url) {
        var params = {};
        params.catEntryID = catentryID;
        params.ProductDisplayURL = Url;
        params.storeId = $('#storeId').val();
        params.catalogId = $('#catalogId').val();
        params.langId = $('#langId').val();
        $.ajax({
            type: "GET",
            url: "PDPBazaarVoiceView",
            dataType: "html",
            data: params,
            cache: false,
            async: false,
            success: function(response) {
                $("#wcs-bazaarvocie").html('');
                $("#wcs-bazaarvocie").html(response);
            }
        });
    };

    custom_scrollable_hover();
}
/*
 * ------------------------------------------------------------------------
 * CATEGORY LISTING FUNCTION ENDS
 * --------------------------------------------------------------------------
 */
